import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import StatusBadge from "@/components/StatusBadge";
import { Broadcast, Clock, MapPin, Users } from "@phosphor-icons/react";

const stateBadge = {
  in_progress: "bg-red-500 text-white animate-pulse",
  upcoming: "bg-yellow-400 text-yellow-950",
  past: "bg-slate-300 text-slate-800",
};

export default function AdminLive() {
  const [items, setItems] = useState([]);
  const [tick, setTick] = useState(0);
  const load = () => api.get("/admin/live-shifts").then((r) => setItems(r.data));
  useEffect(() => {
    load();
    const id = setInterval(() => { load(); setTick(t => t+1); }, 15000);
    return () => clearInterval(id);
  }, []);

  const inProgress = items.filter(i => i.live_state === "in_progress").length;
  const upcoming = items.filter(i => i.live_state === "upcoming").length;
  const past = items.filter(i => i.live_state === "past" && i.status === "confirmed").length;

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <Broadcast size={28} className="text-red-500" weight="fill" />
        <div>
          <div className="label-caps">Right now</div>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Live Ops</h1>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <Metric label="In progress" value={inProgress} highlight />
        <Metric label="Upcoming today" value={upcoming} />
        <Metric label="Awaiting attendance" value={past} />
      </div>

      <div className="space-y-2">
        {items.length === 0 && <div className="text-slate-500 py-10 text-center card-tactile">No shifts scheduled today.</div>}
        {items.map((b) => (
          <div key={b.id} data-testid={`live-${b.id}`} className="card-tactile p-4">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`inline-flex items-center rounded-md px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider ${stateBadge[b.live_state] || "bg-slate-200 text-slate-700"}`}>{b.live_state}</span>
                  <StatusBadge status={b.status} />
                  {b.attendance_status && <span className="text-xs font-bold uppercase tracking-wider text-slate-600">Att: {b.attendance_status}</span>}
                </div>
                <div className="font-display text-lg font-bold text-slate-900">{b.job?.title}</div>
                <div className="text-sm text-slate-600">{b.job?.company_name} · Staff: {b.staff?.first_name} {b.staff?.last_name}</div>
                <div className="mt-1 flex flex-wrap gap-3 text-sm text-slate-700">
                  <span className="flex items-center gap-1.5"><Clock size={14}/>{b.start_time}–{b.end_time}</span>
                  <span className="flex items-center gap-1.5"><MapPin size={14}/>{b.job?.location}</span>
                </div>
              </div>
              <div className="text-right"><div className="font-display text-lg font-extrabold">£{b.gross_amount}</div></div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-xs text-slate-500">Auto-refreshing every 15s · updated {tick} times.</div>
    </div>
  );
}

function Metric({ label, value, highlight }) {
  return (
    <div className={`card-tactile p-4 ${highlight ? "border-red-200 bg-red-50" : ""}`}>
      <div className="label-caps">{label}</div>
      <div className={`font-display text-3xl font-extrabold ${highlight ? "text-red-600" : "text-slate-900"}`}>{value}</div>
    </div>
  );
}
